<template>
  <div :id="id" class="comparison">
    <div class="componata-container">
      <FancyHeading class="comparison__heading" data-aos="fade-down">
        <template v-slot:title><span v-html="content.title"></span></template>
        <template v-slot:description>{{ content.description }}</template>
      </FancyHeading>

      <div class="comparison__table --is-table-desktop">
        <div
          v-for="(row, rowIndex) in content.table"
          :key="rowIndex"
        >
          <div
            v-if="row.row_type == 'tier'"
            class="comparison__tr --is-th"
          >
            <div class="comparison__td"></div>
            <div
              v-for="(tier, tierIndex) in row.tiers"
              :key="tierIndex"
              class="comparison__td"
            >
              <div class="comparison__tier" v-html="tier.tier"></div>
            </div>
          </div>

          <div
            v-if="row.row_type == 'group'"
            class="comparison__tr --is-group"
          >
            <div class="comparison__td">
              <div class="comparison__group">
                <span class="comparison__icon" v-html="row.group_icon"></span>

                <b>{{ row.group_name }}</b>
              </div>
            </div>
          </div>

          <div
            v-if="row.row_type === 'feature'"
            class="comparison__tr"
          >
            <div class="comparison__td --is-feature">
              {{ row.feature_title }}
              <span><a
                v-if="row.feature_description"
                @click="openRow === rowIndex ? openRow = 0 : openRow = rowIndex"
                class="comparison__more-info-toggle"
              >
                {{ openRow === rowIndex ? 'Details ausblenden' : 'Details anzeigen' }}
              </a></span>

              <p class="comparison__description" v-if="row.feature_description && openRow === rowIndex" v-html="row.feature_description"></p>
            </div>

            <td
              class="comparison__td --is-mark"
              v-for="(mark, markIndex) in row.feature_marks"
              :key="markIndex"
            >
              <slot v-if="mark.mark_type == '0'">
                <span class="comparison__icon --is-green" v-html="checkIcon"></span>
              </slot>

              <slot v-if="mark.mark_type == '1'">
                <span class="comparison__icon --is-gray" v-html="forbiddenIcon"></span>
              </slot>

              <slot v-if="mark.mark_type == '2'">
                {{ mark.mark_content }}
              </slot>
            </td>
          </div>
        </div>
      </div>

      <v-slot v-if="content.table[0].row_type === 'tier'">
        <div
          v-for="(item, index) in content.table[0].tiers"
          :key="index"
          class="comparison__cluster-item --is-table-mobile"
        >
          <div class="comparison__cluster" @click="openCluster === index ? openCluster = null : openCluster = index">
            <div>
              <h4 v-html="item.tier"></h4>
              <p>Expand details…</p>
            </div>

            <i class="icon" :class="openCluster === index ? 'icon-angle-up' : 'icon-angle-down'"></i>
          </div>

          <transition name="comparison__expand-details" appear>
            <div v-if="openCluster === index" class="comparison__table">
              <div
                v-for="(row, rowIndex) in onlyFeatures"
                :key="rowIndex"
              >
                <div
                  v-if="row.row_type == 'group'"
                  class="comparison__tr --is-group"
                >
                  <div class="comparison__td">
                    <div class="comparison__group">
                      <span class="comparison__icon" v-html="row.group_icon"></span>

                      <b>{{ row.group_name }}</b>
                    </div>
                  </div>
                </div>

                <div
                  v-if="row.row_type === 'feature'"
                  class="comparison__tr"
                >
                  <div class="comparison__td --is-feature">
                    {{ row.feature_title }}
                    <span><a
                      v-if="row.feature_description"
                      @click="openRow === rowIndex ? openRow = 0 : openRow = rowIndex"
                      class="comparison__more-info-toggle"
                    >
                      {{ openRow === rowIndex ? 'Details ausblenden' : 'Details anzeigen' }}
                    </a></span>

                    <p class="comparison__description" v-if="row.feature_description && openRow === rowIndex" v-html="row.feature_description"></p>
                  </div>

                  <td
                    class="comparison__td --is-mark"
                  >
                    <slot v-if="row.feature_marks[index].mark_type == '0'">
                      <span class="comparison__icon --is-green" v-html="checkIcon"></span>
                    </slot>

                    <slot v-if="row.feature_marks[index].mark_type == '1'">
                      <span class="comparison__icon --is-gray" v-html="forbiddenIcon"></span>
                    </slot>

                    <slot v-if="row.feature_marks[index].mark_type == '2'">
                      {{ row.feature_marks[index].mark_content }}
                    </slot>
                  </td>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </v-slot>
    </div>
  </div>
</template>

<script>

import FancyHeading from '@/components/Pages/FancyHeading';
export default {
  name: 'Comparison',
  components: {
    FancyHeading
  },
  props: {
    id: {
      type: String,
      default: 'comparison'
    },
    content: {
      type: Object
    }
  },
  data () {
    return {
      checkIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20" width="20"><defs></defs><title>check-circle-1</title><path d="M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px"></path><circle cx="12" cy="11.999" r="11.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px"></circle></svg>',
      forbiddenIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20" width="20"><defs></defs><title>delete-1</title><circle cx="11.998" cy="12" r="11.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px"></circle><line x1="7.498" y1="16.5" x2="16.497" y2="7.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2px"></line><line x1="16.498" y1="16.5" x2="7.497" y2="7.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line></svg>',
      openRow: 0,
      openCluster: null
    };
  },
  methods: {
  },
  computed: {
    onlyFeatures () {
      return this.content.table.filter(item => item.row_type === 'feature' || item.row_type === 'group');
    }
  },
  created () {
    this.content.table.forEach((item, index) => {
      if (item.row_type === 'feature') {
        this.content.table[index].open = false;
      }
    });
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
/**
 * Comparison
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Content section for comparing features versus order quantity
 * @since 2023-05-09
**/

$component: 'comparison';

.#{$component} {
  @include padding((map-get($spacers, 6) * 2) 0);
  // background: $white  url('~@/assets/images/christmas-page/testimonials-bgr.svg') center top no-repeat;

  &__heading {
    --from: #212B36;
    --to: #235994;
    --shadow: #ffffff01;

    width: 60%;
    @include margin(0 auto (map-get($spacers, 6) * 1) auto);
    text-align: center;
  }

  &__table {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &__tr {
    display: flex;
    align-items: center;
    // outline: 1px solid red;
    &:not(.--is-group) {
      border-bottom: 1px solid $sky;
    }

    &:not(.--is-th, .--is-group) {
      @include hover () {
        background-color: $sky-lighter;
      }
    }

    &.--is-group {
      @include padding-top(map-get($spacers, 3));

      .#{$component}__td {
        flex-basis: 100% !important;
        @include padding-bottom(map-get($spacers, 2));
      }
    }

    &.--is-th {
      position: sticky;
      top: 68px;
      background-color: white;
    }

    .#{$component} {
      &__td {
        flex-basis: 15%;
        // outline: 1px solid green;
        @include padding(map-get($spacers, 3) map-get($spacers, 1));

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(5) {
          // background-color: $sky-light;
        }

        &:first-child {
          flex-basis: 40%;
        }

        &.--is-feature {
          display: flex;
          flex-direction: column;
          color: $ink-light;
        }

        &.--is-mark {
          text-align: center;
          color: $ink-lightest;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  &__icon {
    display: flex;
    @include rfs(1.3rem, width);
    @include rfs(1.3rem, height);

    svg {
      @include rfs(1.3rem, width);
      @include rfs(1.3rem, height);
    }

    &.--is-green {
      color: darken($green, 4%);
    }

    &.--is-gray {
      color: $ink-lightest;
    }
  }

  &__tier {
    text-align: center;

    ::v-deep {
      b,
      span {
        display: block;
      }

      b {
        @include font-size($font-size-lg);
      }

      span {
        color: $ink-light;
      }
    }
  }

  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    @include font-size($font-size-lg);

    .#{$component}__icon {
      @include margin-right(map-get($spacers, 2));
      color: $ink-lighter;
    }
  }

  &__more-info-toggle {
  }

  &__description {
    @include margin-top(map-get($spacers, 3));
    color: $ink-lighter;
    @include font-size($font-size-base);

    ::v-deep {
      p {
        margin: 0;
        @include font-size($font-size-sm);
      }
    }
  }

  &__cluster-item {
    & + & {
      @include margin-top(map-get($spacers, 4));
    }

    .#{$component} {
      &__cluster {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include padding(map-get($spacers, 2) map-get($spacers, 4));
        border-radius: $border-radius-lg;
        background-color: $sky-light;
        cursor: pointer;

        > div {
          display: flex;
          flex-direction: column;
        }

        h4,
        p {
          margin: 0;
        }

        h4 {
          @include margin-bottom(map-get($spacers, 2));

          ::v-deep {
            b {
              font-weight: 700 !important;
            }
            span {
              font-weight: normal;
            }
          }
        }

        p {
          color: $ink-lighter;
        }

        .icon {
          @include font-size(3rem);
          color: $ink-light;
        }
      }

      &__table {

      }

      &__td:first-child {
        flex-basis: 70%;
      }
      &__td:last-child {
        flex-basis: 30%;
      }
    }
  }

  .--is-table-mobile {
    display: none;
  }

  // Transition
  &__expand-details {
    &-enter-active,
    &-leave-active {
      opacity: 1;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-md')) {
    &__heading {
      width: 70%;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-sm')) {
    &__heading {
      width: 80%;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-xs')) {
    &__heading {
      width: 90%;
    }

    .--is-table-desktop {
      display: none;
    }

    .--is-table-mobile {
      display: block;
    }
  }
}
</style>
